export const maleSpeakers = [
    { value: "en-GB-OllieMultilingualNeural", label: "en-GB-OllieMultilingualNeural" },

]

export default maleSpeakers;